<template>
  <div class="mb-audit-comment-h5tag">
    <!-- 标题 -->
    <div v-if="!hidden">
      <div class="comment-title" :class="{'comment-required': required || needElecseal || needEsignature}" v-if="label">{{label}}</div>
      <template v-if="schema != 'default' || (showCurComment && taskId && !isFinishedTask)">
        <!-- 是否同意radio -->
        <template v-if="checkboxOnly && mergeOptions.length === 1 && showInput">
          <van-row class="comment-approval">
            <van-checkbox v-model="approval_checkbox" :disabled="mergeOptions[0].disabled">{{mergeOptions[0].name}}</van-checkbox>
          </van-row>
        </template>
        <template v-else>
          <van-radio-group v-model="approval" v-if="mergeOptions.length && showInput">
            <van-row class="comment-approval">
              <van-col v-for="(item, index) in mergeOptions" :key="index" class="comment-approval-col">
                <van-radio :name="item.id" :disabled="item.disabled">{{item.name}}</van-radio>
              </van-col>
            </van-row>
          </van-radio-group>
        </template>
        <van-row class="comment-sample" v-if="sample && showInput && !readonly">
          <van-col class="comment-sample-label" @click="showSample">
            常用意见 <van-icon name="arrow-down" v-if="!samplePopup" style="margin-left: 4px;"/><van-icon name="arrow-up" v-if="samplePopup" style="margin-left: 4px;"/>
          </van-col>
          <van-col class="comment-sample-label save-sample" :class="{'disabled': !comment}" @click="saveSample">保存为常用意见</van-col>
        </van-row>
        <!-- 意见填写区 -->
        <van-field v-model.trim="comment" type="textarea" class="comment-text" :placeholder="placeholder" :autosize="autosize" :maxlength="maxlength" v-if="showInput" :readonly="readonly"/>
        <!--引入添加印章区域 -->
        <template v-if="!getSealLoading">
          <!--4：诺安 -->
          <template v-if="(elecseal || esignature) && signatureType == '4'">
            <div class="e-mb-signature-wrap">
              <nuo-seal ref="nuoSeal" :sealConfigData="sealConfigData" :nuo-seal="nuoSeal"></nuo-seal>
            </div>
          </template>
          <!--3：e钱宝 -->
          <template v-else-if="(elecseal || esignature) && signatureType == '3' && hasLoaded">
            <div class="e-mb-signature-wrap">
              <e-seal ref="eSeal"></e-seal>
            </div>
          </template>
          <template v-else>
            <template v-if="signatureType == '1'">
              <!-- 印章/签名 -->
              <div class="chapter-wraper" v-if="(elecseal || esignature)">
                <div class="chapter-item" v-for="(item, index) in chapterUrl" :key="index">
                  <img :src="item" class="chapter-img"/>
                  <a class="chapter-delete" @click.stop="delSeal(item, index)" v-if="!readonly"></a>
                </div>
                <div class="chapter-item chapter-empty" @click="sealSelect" v-if="showChapterAdd"></div>
              </div>
            </template>
            <template v-else-if="signatureType == '2'">
              <div class="chapter-wraper">
                <div class="chapter-item" :class="{ 'chapter-empty': !item.hasChapter }" @click="sealSelect(item.pos)" v-for="item in mbRenderPosArr" :id="item.pos" :key="item.pos" v-show="item.visible"></div>
              </div>
            </template>
          </template>
        </template>
      </template>
    </div>
    <!--移动端暂时不暂时 -->
    <!-- <van-collapse v-model="activeName"  v-if="schema ==='default' && showOldComment && taskId" accordion class="history-comment">
      <van-collapse-item title="查看其它意见" name="history">
        <template #right-icon>
          <van-icon :name="activeName ? 'arrow-up' : 'arrow-down'" class="history-item-icon" v-if="!historyLoading"/>
          <van-loading type="spinner" size="24px" v-else/>
        </template>
        <div class="history-comment-content" v-for="(item,key) in flowComments" :key="key">
          <div class="history-comment-title"><label><span style="margin-right: 4px;">{{item.nodeName}}</span>意见：</label></div>
          <div class="history-comment-text">{{item.comment}}</div>
          <div class="history-comment-chapter"> -->
            <!--点击验证签章是否签订成功 -->
            <!-- <img :src="item.elecsealurl" v-if="item.elecseal && !item.pos"  @click="handleCheckSeal(item)"/>
            <van-loading v-if="item._waiting" class="verify-seal" color="#1989fa" type="spinner"/>
            <div :id="item.pos"  class="elecseal-pos" v-if="item.elecseal && item.pos"></div>
          </div>
          <div class="history-comment-time"><label><span style="margin-right: 4px;">{{item.deptName}}</span><span style="margin-right: 8px;">{{item.userName}}</span><span>{{item.endTime}}</span></label></div>
        </div>
        <div class="history-comment-empty" v-if="historyEmpty">暂无数据</div>
      </van-collapse-item>
    </van-collapse> -->
    <!--常用意见-->
    <van-popup
      v-model="samplePopup" 
      position="bottom"
      get-container="body"
      :style="{ width: '100%'}"
      class="show-common-opinions">
      <van-nav-bar title="常用意见" @click-right="samplePopup = false">
        <template #right>
          <van-icon name="cross" size="18" />
        </template>
      </van-nav-bar>
      <template v-if="defaultComments.length>0">
        <ul class="comment-sample-box-m">
          <li class="comment-sample-item-m" v-for="(item, index) in defaultComments" :key="index" :title="item.NAME" @click="chooseComment(item)" :class="[{'active': item.active}]">
            <span class="sample-text-m">{{item.NAME}}</span>
          </li>
        </ul>
      </template>
      <template v-else>
        <van-empty description="暂无数据" /> 
      </template>
    </van-popup>
    <seal-modal
      ref="sealModal" 
      v-model="chapterPopup"
      :chapterWID="chapterWID"
      :elecseal="elecseal"
      :esignature="esignature && signatureType == '1'"
      :signatureType="signatureType"
      :needElecseal="needElecseal"
      :needEsignature="needEsignature"
      :clip="clip"
      :multiple="multiple"
      @on-confirm="elecsealConfirm">
    </seal-modal>
    <!-- 默认模式下，印章二次验证 -->
    <second-verification v-model="secondVerModal" @on-pass="onVerifyPass"></second-verification>
    <!--signatureType:4 时诺安的签章验证弹框 -->
    <van-popup v-model="showDialog" class="nuo-seal-dialog"  position="bottom" closeable :close-on-click-overlay="false" :style="{ height: '22%' }">
      <div class="del-btns">
        <div class="del-btns-top">电子签章</div>
        <van-divider />
        <div v-if="isSuccess" class="del-btns-bottom">
          <div class="check-icon-succ-m"></div>
          <div class="check-text-m text-success">验签成功</div>
        </div>
        <div v-else class="del-btns-bottom">
          <div class="check-icon-fail-m"></div>
          <div class="check-text-m text-fail">验签失败</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import api from '@/api/comment'
  import commentMixin from "mixins/emapflow-comment"
  import SealModal from './modals/seal-modal.vue'
  import SecondVerification from "./features/second-verification"
  import ESeal from 'components/eseal'
  import NuoSeal from 'components/nuo-seal'
  import KingGridMixin from 'mixins/kinggrid'
  import "../nuo-seal/css/style.css"
  export default {
    name: "emap-flow-comment-m",
    data() {
      return {
        isMobile: true,
        placeholder: '请输入意见',
        autosize: { maxHeight: 100, minHeight: 80 },
        chapterPopup: false,
        samplePopup: false,
        sealChecked: null,
        secondVerModal: false,  // 默认模式下的二次验证dialog
        tempWIDS: [],  // chapterWID 临时存储
        tempURLS: [],  // chapterUrl 临时存储
        tempBase64: '', // 签名生成的base64 临时存储
        approval_checkbox: !(this.value?.approval === ''),
        activeName: '',
        historyLoading: false,
        historyEmpty: false,
        showDialog:false,
        isSuccess:false,//签章校验是否成功
      }
    },
    props: {
      maxlength: {
        type: Number,
        default: 200
      },
      field: String
    },
    components: {
      ESeal,SecondVerification, SealModal,NuoSeal
    },
    mixins: [commentMixin, KingGridMixin],
    watch: {
      approval: function(newval) {
        if(newval == null) return
        if(this.checkboxOnly && this.mergeOptions.length == 1) {
          this.approval_display = !newval ? '' : this.mergeOptions[0].name;
          this.$nextTick(() => {
            this.$emit('approval-change', newval, this.field, this.mergeOptions[0]);
          })
        } else {
          let option = this.mergeOptions.filter((opt)=>{ return opt.id === newval})[0];
          if(!option) return
          this.approval_display = option.name;
          this.$emit('approval-change', option.id, this.field, option);
        }
        //this.emitInput();
      },
      comment: function(newval) {
        if(newval) this.validateError = false;
        this.emitInput()
      },
      chapterWID: function(newVal) { //新增方法
        this.$emit('inputBlur', newVal);
      },
      chapterUrl:function(newVal){ //新增方法
        this.$nextTick(() =>{
          this.$emit('inputChapterUrl',newVal)
        })
      },
      chapterPopup(val) {
        if (!val) {
          if (this.dialog && this.dialog.remove) {
            this.dialog.remove()
          }
        }
      },
      approval_checkbox(val) {
        this.approval = val ? this.mergeOptions[0].id : '';
      }
    },
    computed: {
      showChapterAdd() {
        if(this.multiple) {
          return (!this.readonly && this.chapterUrl.length < 2) || (this.readonly && this.chapterUrl.length == 0)
        } else {
          return this.chapterUrl.length == 0
        }
      }
    },
    methods: {
      handleCheckSeal(item, autoCheck) {
        console.log(item, '触发诺安电子签章：handleCheckSeal')
        if (this.signatureType === '4') {
          autoCheck = autoCheck || false
          const _waiting = item._waiting
          if (_waiting) return
          this.$set(item, '_waiting', true)
          this.nuoSeal.checkSign(item, (status, data, base64) => {
            if (status === '0' || status === '1') {
              this.showDialog = true
              this.isSuccess = status === '0' ? true : false
            } else if (status === '3') {
              item.elecsealurl = [base64] // 诺安，目前只有一个
            }
            this.$set(item, '_waiting', false)
          }, autoCheck)
        }
      },

      autoCheckAllSign(list) {
        console.log('自动验签----mobile')
          if (this.signatureType === '4') {
          list.forEach(item => {
            this.handleCheckSeal(item, true)
          })
        }
      },

      handelBtnClose(){
        this.showDialog = false;
        this.isSuccess = false
      },

      showSample() {
        this.$toast.loading({
          "overlay": true,
          "loadingType": "spinner",
          "duration": 0,
          "className": "custom-loading"
        })
        let params = {
          "DEFKEY": this.defKey,
          "pageFlag": 1
        }
        api.getCommentSample(params).then(data => {
          this.$toast.clear();
          if(data && data.code == '0') {
            this.defaultComments = data.datas.queryComment.rows;
            this.defaultComments = this.defaultComments.map(row =>{
              row.active = this.comment === row.NAME;
              return row           
            })
            this.samplePopup = true;
          }
        })
      },
      chooseComment(item) {
        this.samplePopup = false;
        this.comment = item.NAME;
      },
      saveSample() {
        if(!this.comment) return
        api.saveComment({'NAME': this.comment, "DEFKEY": this.defKey}).then(data => {
          if(data.code == '0') {
            this.$toast.success("保存成功");
          } else {
            this.$toast.fail(data.msg);
          }
        })
      },
      sealSelect(pos) {
        if(this.getSealLoading || this.readonly) return;
        if (this.signatureType != '2') {
          this.chapterPopup = true
        } 
        if (this.signatureType == '2' && this.elecseal) {
          if (this.iskinggrid) {
            this.createKingGridSeal(pos)
          } else {
            console.error('kinggrid属性以及kinggrid.documentid必传!!')
          }
        }
      },
      delSeal(item, index) {
        let wid = item.indexOf('&_=')> -1 ? item.slice(item.indexOf('wid=') + 4, item.indexOf('&_=')) : item.slice(item.indexOf('wid=') + 4);
        let widsStr = this.chapterWID.split(',');
        this.chapterWID = widsStr.filter(item => item!==wid)[0] || '';
        this.chapterUrl.splice(index, 1);
        this.emitInput();
      },
      elecsealConfirm(wids, urls, base64) {
        this.tempWIDS = wids;
        this.tempURLS = urls;
        this.tempBase64 = base64;
        if (this.signatureType == '2') {
          if (this.onOk) {
            this.onOk.call(this.kingGridCon)
          }
        } else if (this.signatureType == '1' && this.sealverify){
          this.secondVerModal = true;
        } else {
          this.onVerifyPass();
        }
      },
      // 签章选择默认模式下的确定
      onVerifyPass() {
        this.chapterUrl = JSON.parse(JSON.stringify(this.tempURLS));
        this.tempURLS = [];
        if(!this.tempBase64) {
          this.chapterWID = this.tempWIDS.join(',');
          this.tempWIDS = [];
          this.emitInput();
          this.chapterPopup = false;
        } else {
          api.saveSignatrue({ 
              "elecSignData": this.tempBase64
            }).then(data => {
              if(data && data.code === "0" && data.datas && data.datas.submitElecSignMobile === 1) {
                this.chapterUrl.push(this.loadSeal + '?wid=' + data.datas.WID + "&_=" + new Date().getTime());
                this.tempWIDS.push(data.datas.WID);
                this.chapterWID = this.tempWIDS.join(',');
                this.tempWIDS = [];
                this.tempBase64 = '';
                this.emitInput();
                this.chapterPopup = false;
              }
            })
        }
      },
      validate() {
        let result = this.validateDefault();
        if(!result.valid) this.$toast(result.msg);
        return result.valid
      }
    }
  };
</script>
<style lang="css" scoped>
  .mb-audit-comment {
    font-size: 16px;
  }
 
  .mb-audit-comment:after {
    content: '';
    display: table;
  }
  .history-comment-content {
    position: relative;
    padding: 15px 17px 73px;
    border-bottom: 1px solid #EDF2FB;
  }
  .history-comment-title {
    font-size: 14px;
  }
  .history-comment-text {
    text-indent: 2em;
    font-size: 14px;
    margin: 10px 0;
    min-height: 40px;
    margin-right: 74px;
  }
  .history-comment-time {
    font-size: 14px;
    position: absolute;
    right: 30px;
    bottom: 10px;
    z-index: 2;
  }
  .history-comment-chapter {
    position: absolute;
    max-height:74px;
    max-width: 74px;
    right: 30px;
    bottom: 40px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
  }
  .history-comment-chapter img{
    display: block;
    max-width: 100px;
    max-height: 74px;
  }
  .history-comment >>>.van-collapse-item__content {
    padding: 0;
    overflow: auto;
    max-height: 520px;
  }
  
  .history-item-icon {
    display: inline-flex;
    align-items: center;
  }
  .history-comment-empty {
    padding: 10px 16px;
    line-height: 24px;
    text-align: center;
    color: #969799;
  }
  .comment-title {
    padding: 12px 16px 8px 16px;
    font-size: 16px;
    color: #13152D;
    box-shadow: inset 0 -1px 0 0 #EDF2FB;
  }
  .comment-required::before {
    position: absolute;
    left: 8px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
  }
  .comment-approval {
    padding: 7px 16px 8px 16px;
  }
  .comment-approval-col {
    padding-top: 3px; 
    padding-bottom: 2px;
    margin-right: 10px;
  }
  .chapter-wraper {
    display: flex;
  }
  .chapter-item {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 16px;
    border-radius: 4px;
    height: 74px;
    width: 74px;
    margin: 12px 0 12px 17px;
    background: #F7FAFF;
    border: 1px solid #C4C9D9;
  }
  .chapter-empty::before {
    position: absolute;
    top: 35px;
    left: 21px;
    content: "";
    display: block;
    width: 30px;
    height: 2px;
    background: #C4C9D9;
  }
  .chapter-empty::after {
    position: absolute;
    top: 21px;
    left: 35px;
    content: "";
    display: block;
    width: 2px;
    height: 30px;
    background: #C4C9D9;
  }
  .chapter-img {
    display: block;
    max-height: 100%;
    max-width: 100%;
    margin: 0 auto;
    border-radius: 4px;
  }
  .chapter-delete {
    position: absolute;
    right: -10px;
    top: -10px;
    height: 20px;
    width: 20px;
    background: #ccc;
    border-radius: 50%;
    display: block;
  }
  .chapter-delete:before {
    position: absolute;
    content: "";
    top: 10px;
    left: 5px;
    display: block;
    width: 10px;
    height: 1px;
    background: #fff;
    transform: rotate(45deg);
  }
  .chapter-delete:after {
    position: absolute;
    left: 10px;
    top: 5px;
    content: "";
    display: block;
    width: 1px;
    height: 10px;
    background: #fff;
    transform: rotate(45deg);
  }
  
  .comment-sample {
    padding: 5px 16px;
    color: #3B7BFF;
  }
  .comment-sample-label {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
  .comment-sample-label:last-child {
    float: right;
  }
  .comment-sample-box-m {
    max-height: calc(80vh - 50px);
    overflow: auto;
    background-color: #fff;
    padding: 16px;
  }
  .comment-sample-item-m {
    padding: 7px;
    font-size: 14px;
    color: #13152D;
    background: #EDF2FB;
    border-radius: 4px;
  }
  .comment-sample-item-m.active {
    color: #3B7BFF;
  }
  .comment-sample-item-m:not(:last-child) {
    margin-bottom: 16px;
  }
  .disabled {
    opacity: 0.5;
  }
  .save-sample:after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background-color: #000;
    border: inherit;
    border-color: #000;
    border-radius: inherit;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    opacity: 0;
    content: ' ';
  }
  .save-sample:not(.disabled):active:after {
    opacity: 0.1;
  }
  .custom-loading {
    background-color: transparent;
  }

</style>
<style>
 .show-common-opinions .van-empty {
   display: flex;
   align-items: center;
   flex-direction: column;
   height: 100%;
   justify-content: center;
 }
 .show-common-opinions .van-empty__image {
   width: 160px;
   height: 160px;
 }
 .show-common-opinions .van-empty__image img {
   width:100%;
   height: 100%;
 }

.nuo-seal-dialog  .del-btns {
  height: 100%;
  text-align: center;
}
.nuo-seal-dialog .del-btns .del-btns-top {
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.nuo-seal-dialog .del-btns .del-btns-bottom {
  height: calc(100% - 42px);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nuo-seal-dialog .van-popup__close-icon {
  font-size: 18px;
}
.nuo-seal-dialog .van-popup__close-icon--top-right {
  top: 12px;
  right: 12px;
}

.nuo-seal-dialog .del-btns .van-divider {
  margin: 0;
}

.history-comment-chapter .verify-seal {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: rgba(255,255,255,0.7);
}
.history-comment-chapter .verify-seal .van-loading__spinner {
  width: 20px;
  height: 20px;
}


  .tabs-content .tab-panel .kg-switcher {
    padding-top: 40px;
  }
  .tabs-content .tab-panel .kg-sm-2 {
    width: 13%;
  }
  .tabs-content .tab-panel .kg-form {
    margin-top: 25px;
  }
  .ui-popup.ui-popup-modal[role="alertdialog"] {
    z-index: 19930903 !important;
  }
  .kg-img-div.kg-default,.kg-img-div.kg-default img{
    width: 74px !important;
    height: 74px!important;
  }
  .e-mb-signature-wrap {
    padding: 10px 17px;
  }
</style>
